import type { HideToastsByTagAction } from "app/actions/toast_actions";
import { hideToastsByTag } from "app/actions/toast_actions";

import type { ActiveExportFlowPhase, ExportFlowPhase } from "../types/exportFlow";

export const EXPORT_SUCCESS_TAG = "export-success";

export const hideExportSuccessToasts = (): HideToastsByTagAction => hideToastsByTag(EXPORT_SUCCESS_TAG);

export const IDLE_PHASE: ExportFlowPhase = { type: "idle" };

export const isExportFlowActive = (phase: ExportFlowPhase): phase is ActiveExportFlowPhase => phase.type !== "idle";
